<app-dashboard>
  <div class="w-full flex flex-col p-[20px]">
    <div *ngIf="canWrite" class="w-full flex justify-end">
      <app-button
        [label]="'Invite Member'"
        (onClick)="openCreateModal()"
        [className]="
          'text-[#fff] max-w-[150px] w-full h-[50px] flex items-center whitespace-nowrap justify-center rounded-[5px] bg-[#081A46] cursor-pointer'
        "
      ></app-button>
      <div *ngIf="!canWrite" class="w-full h-[30px]"></div>
    </div>
    <div class="w-full mt-[30px]">
      <div class="border-b flex gap-[15px]">
        <div
          *ngFor="let type of inviteType"
          (click)="setInviteType(type)"
          class="transition-all duration-300 ease-in-out flex flex-col gap-[3px] cursor-pointer"
        >
          <span
            class="px-[10px] font-[700] {{
              currentinviteType === type ? 'text-[#081A46]' : 'text-slate-500'
            }}"
            >{{ type }}</span
          >
          <div
            *ngIf="currentinviteType === type"
            class="h-[2px] rounded-t-[2px] bg-[#081A46] w-full"
          ></div>
        </div>
      </div>
      <div class="w-full p-[20px]">
        <app-table
          [tableData]="tableData"
          [tableHeader]="tableHeader"
          (rowClick)="openDetailsModal($event)"
          [tableTitle]="'Transactions'"
          [loading]="fetchingData"
          [emptyState]="emptyTableState"
          [filterData]="filterData"
          (handleFilter)="applyFilter($event)"
          (handleSearch)="search($event)"
          [tableWidth]="' min-w-[990px]'"
          [toolbar]="{
            paginate: true,
            search: true,
            filter: true,
            addnew: false
          }"
          [paginationData]="{
            limit: limit,
            totalData: totalMembers
          }"
          (changeLimit)="changeLimit($event)"
        >
          <div class="flex justify-end items-center sm:w-full">
            <app-pagination
              *ngIf="!fetchingData && this.totalMembers > 0"
              [totalItems]="this.totalMembers"
              [(pageSize)]="this.limit"
              [(currentPage)]="this.page"
              (pageSizeChange)="this.refreshList()"
              (currentPageChange)="this.getInvites()"
            ></app-pagination>
          </div>
        </app-table>
      </div>
    </div>
  </div>
</app-dashboard>
<app-modal
  [title]="'Create Membership Request'"
  [isOpen]="createModalOpen"
  (closeModalEvent)="closeCreateModal()"
>
  <div class="w-full flex flex-col">
    <div class="w-full flex flex-col sm:grid sm:grid-cols-2 sm:gap-[20px]">
      <app-input
        (returnValue)="handleInput($event)"
        [title]="'firstName'"
        [error]="errors.firstName"
        [label]="'First Name'"
        [placeholder]="'Enter first name..'"
      />
      <app-input
        (returnValue)="handleInput($event)"
        [title]="'lastName'"
        [error]="errors.firstName"
        [label]="'Last Name'"
        [placeholder]="'Enter last name..'"
      />
    </div>
    <app-input
      (returnValue)="handleInput($event)"
      [title]="'emailAddress'"
      [error]="errors.emailAddress"
      [label]="'Email Address'"
      [placeholder]="'Enter email address..'"
    />
    <span class="text-slate-800 font-[600] text-[18px]">User Roles:</span>
    <div class="border border-grey-300 rounded-[10px] p-[10px] mb-[20px]">
      <div
        *ngFor="let role of newMember?.roles; index as roleIndex"
        class="w-full grid grid-cols-[30%_1fr_5%] gap-[20px]"
      >
        <app-dropdown
          [label]="'Role'"
          [placeholder]="'eg.. admin'"
          [title]="'roles'"
          [error]="errors.roles"
          (selectedValue)="handleRoleTitle($event, roleIndex)"
          [items]="userRoles"
        />
        <div class="w-full flex justify-center items-center">
          <app-checkbox-group
            [titles]="permissions"
            (selectionChange)="handleSelection($event, roleIndex)"
          />
        </div>
        <img
          (click)="removeRole(roleIndex)"
          src="../../../assets/icons/delete.svg"
          alt=""
        />
      </div>
    </div>
    <div
      (click)="addRole()"
      class="border cursor-pointer border-gray-300 border-dashed h-[50px] w-full flex justify-center items-center hover:bg-gray-100 rounded-[10px] mb-[20px]"
    >
      <span>Add Role +</span>
    </div>
    <app-button
      [label]="'Invite Member'"
      [loading]="loading"
      (onClick)="inviteMember()"
      [className]="
        'text-[#fff] w-full h-[50px] flex items-center whitespace-nowrap justify-center cursor-pointer rounded-[5px] bg-[#081A46]'
      "
    ></app-button>
  </div>
</app-modal>
<app-side-modal
  [title]="'Member Details'"
  [isOpen]="membershipDetailsOpen"
  (closeModalEvent)="closeDetailsModal()"
>
<div class="w-full flex flex-col gap-[30px]">
  <div class="w-full flex flex-col">
    <span class="text-[25px] text-slate-800 font-[600]">{{(singleMember?.firstName) + ' ' + (singleMember?.lastName)}}</span>
    <span class="text-[12px] text-slate-500 font-[400]">{{singleMember?.createdAt}}</span>
  </div>
  <div class="w-full flex flex-col">
    <div class="w-full flex justify-between">
      <span class="text-[12px] text-[#6B7280] font-[500]">Email:</span>
      <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{singleMember?.emailAddress}}</span>
    </div>
    <div class="w-full flex justify-between">
      <span class="text-[12px] text-[#6B7280] font-[500]">Phone Number:</span>
      <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{singleMember?.phoneNumber}}</span>
    </div>
    <div class="w-full flex justify-between">
      <span class="text-[12px] text-[#6B7280] font-[500]">Status:</span>
      <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{singleMember?.status}}</span>
    </div>
    <div class="w-full flex justify-between">
      <span class="text-[12px] text-[#6B7280] font-[500]">Email:</span>
      <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{singleMember?.emailAddress}}</span>
    </div>
    <span class="text-[20px] text-slate-800 font-[600] mt-[10px]">Roles</span>
   <div *ngFor="let role of singleMember?.membership?.roles">
    <div class="w-full flex justify-between">
      <span class="text-[12px] text-[#6B7280] font-[500]">Roles:</span>
      <span class="text-[13px] text-[#1F2937] font-[600] text-right capitalize">{{role?.role}}</span>
    </div>
    <div class="w-full flex justify-between">
      <span class="text-[12px] text-[#6B7280] font-[500]">Permissions:</span>
      <span class="text-[13px] text-[#1F2937] font-[600] text-right">{{role?.permissions}}</span>
    </div>
   </div>
  </div>
</div>
</app-side-modal>
